<template>
    <div class="base-account" :class="{'account-sp': $store.state.screen == 1}">
        <div class="header-top">
            <div class="title">用户中心9</div>
            <div class="service-img" @click="toSer">
                <img src="~images/user_service.png" />
            </div>
        </div>
        <div class="curve-bg">
            <img src="~images/user_bg.png" />
            <div class="header">
                <div class="header-bottom" v-show="iscentent">
                    <input v-show="false" type="file" @change="tirggerFile" mutiple="mutiple" id="files" ref="input" />
                    <img class="logo" :src="logo" @click="openImg" />
                    <div>
                        <div class="real-info">
                            <div class="real-name">{{objData.nick_name || objData.username || '无'}}</div>
                            <div>
                                <img class="real-img" src="~images/user_real_1.png" v-if="objData.vip == 1" />
                                <img class="real-img" src="~images/user_real_0.png" v-else />
                            </div>
                            <div class="real-type" :class="{istype: objData.is_auth == 1}">
                                <span v-if="objData.is_auth == 1">已认证</span>
                                <span v-else>未认证</span>
                            </div>
                        </div>
                        <div class="account">账号：{{objData.username || objData.mobile || '无'}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="member">
            <img src="~images/user_yes_real.png" v-if="objData.vip == 1" />
            <img src="~images/user_not_real.png" v-else />
        </div>
        <div class="quick-box">
            <div class="quick" v-for="(item, index) in quickList" :key="index" @click="toQuick(item.path)">
                <img :src="item.img" />
                <div>{{item.name}}</div>
            </div>
        </div>
        <div class="list-box">
            <div class="list" v-for="(item, index) in infoList" :key="index" @click="onInfo(index)">
                <div class="left">
                    <img :src="item.img" />
                    <span>{{item.name}}</span>
                </div>
                <div class="right">
                    <div class="max-name" v-if="index == 0">{{objData.nick_name || objData.username || '无'}}</div>
                    <span v-if="index == 1">{{objData.mobile || '无'}}</span>
                    <span v-if="index == 3">
                        <span v-if="ispayPwd == 0">去设置</span>
                        <span v-if="ispayPwd == 1">修改</span>
                    </span>
                    <img src="~images/move.png" />
                </div>
            </div>
        </div>
        <div class="list-box setup">
            <div class="list" v-for="(item, index) in setupList" :key="index" @click="onSetup(index)">
                <div class="left">
                    <img :src="item.img" />
                    <span>{{item.name}}</span>
                </div>
                <div class="right">
                    <span v-if="index == 0">管理</span>
                    <span v-if="index == 1">
                        <span v-if="objData.is_auth == 1">修改</span>
                        <span v-else>未认证</span>
                    </span>
                    <div class="switch" :class="{isswitch: isball}" v-if="index == 2" @click="onSuspension">
                        <div class="ball" :class="{isball: isball}"></div>
                    </div>
                    <img src="~images/move.png" v-if="index != 2 && index != 3" />
                </div>
            </div>
        </div>
        <div class="list-box isapp" v-if="isCloudPlay==0">
            <div class="list" @click="onOpen">
                <div class="left">
                    <img src="~images/logo.png" />
                    <span>焕游</span>
                </div>
                <div class="right">
                    <span v-if="isHasBox == 1">打开</span>
                    <span v-if="isHasBox == 0">下载</span>
                    <img src="~images/ismove.png" />
                </div>
            </div>
        </div>
        <transition name="component-fade" mode="out-in">
            <BaseNickname @childName="childName" :name='fslname' v-if="activeInfo == 0" />
            <BasePhone :activeInfo='activeInfo' :phone='objData.mobile' @childPhone="childPhone" v-if="activeInfo == 1" />
            <BasePwdModify @childPwd="childPwd" v-if="activeInfo == 2" />
            <BasePwdPaySetup @childPaySetup="childPaySetup" v-if="activeInfo == 3 && ispayPwd == 0" />
            <BasePwdPayModify :phone='objData.mobile' @childPayModify="childPayModify" v-if="activeInfo == 3 && ispayPwd == 1" />
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
    import BaseNickname     from './BasePopup/BaseNickname'
    import BasePhone        from './BasePopup/BasePhone'
    import BasePwdModify    from './BasePopup/BasePwdModify'
    import BasePwdPaySetup  from './BasePopup/BasePwdPaySetup'
    import BasePwdPayModify from './BasePopup/BasePwdPayModify'
    import TheTips          from '@/components/TheTips'
    import Big from 'big.js';

    export default {
        name: 'BaseAccount',
        components: {
            BaseNickname,
            BasePhone,
            BasePwdModify,
            BasePwdPaySetup,
            BasePwdPayModify,
            TheTips
        },
        data () {
            return {
                msg: null,
                topbg: require('images/user_bg.png'),
                quickList: [
                    {
                        img: require('images/quick_1.png'),
                        name: '返利细则',
                        path: '/base-rebate'
                    },
                    {
                        img: require('images/quick_2.png'),
                        name: '我的钱包',
                        path: '/base-wallet'
                    },
                    {
                        img: require('images/quick_3.png'),
                        name: '账单记录',
                        path: '/base-bill'
                    }
                ],
                infoList: [
                    {
                        img: require('images/info_1.png'),
                        name: '用户昵称'
                    },
                    {
                        img: require('images/info_2.png'),
                        name: '手机换绑'
                    },
                    {
                        img: require('images/info_3.png'),
                        name: '修改密码'
                    },
                    {
                        img: require('images/info_4.png'),
                        name: '支付密码'
                    }
                ],
                setupList: [
                    {
                        img: require('images/info_5.png'),
                        name: '我的小号'
                    },
                    {
                        img: require('images/info_6.png'),
                        name: '实名认证'
                    },
                    {
                        img: require('images/info_7.png'),
                        name: '隐藏悬浮'
                    },
                    {
                        img: require('images/info_8.png'),
                        name: '退出登录'
                    }
                ],
                isball: false,
                activeInfo: null,
                logo: '',
                baselogo: '',
                objData: {},
                uid: null,
                file: null,
                fslname: '',
                ispayPwd: 0,
                iscentent: false,
                isHasBox: -1,
                isCloudPlay:0,//云玩1:是云玩,0不是云玩
                userData:{}
            }
        },
        methods: {
            // onfsl () {
            //     window.location.href = 'https://file.5wt90.cn/app.mobileprovision'
            // },
            toSer () {
                this.$router.push('/base-service')
            },
            toQuick (path) {
                this.$router.push(path)
            },
            onInfo (index) {
                if (index == 1 && !this.objData.mobile) {
                    this.msg = '未绑定手机号'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                } else {
                    this.activeInfo = index
                }
            },
            tirggerFile (event) {
                if (event.target.files[0]) {
                    let that = this
                    let file = event.target.files[0]
                    that.file = file
                    let url = ''
                    var reader = new FileReader()
                    reader.readAsDataURL(file)
                    reader.onload = function(e) {
                        url = this.result.substring(this.result.indexOf(",") + 1)
                        that.baselogo = "data:image/png;base64," + url
                        that.upLoad()
                    }
                }
            },
            openImg () {
                this.$refs.input.click()
            },
            // 修改头像
            upLoad () {
                let formData = new FormData()

                formData.append('id', this.uid)
                formData.append('img', this.file)

                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=upload_img', formData).then(res => {
                    if (res.data.status == 1) {
                        this.logo = this.baselogo
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            // 隐藏悬浮球
            onSuspension () {
                this.isball = !this.isball
                // 存储悬浮按钮状态
                sessionStorage.setItem('setisball', !this.isball)
                if (this.config.system == 2) {
                    this.isball ? window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_float'}) :
                    window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_open_float'})
                } else {
                    this.isball ?window.Android.hideBall():window.Android.showBall()
                }
            },
            // 打开焕游游戏app
            onOpen () {
                if(this.config.system == 2){
                    window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_open_box'})
                } else {
                    window.Android.openBox()
                }
            },
            childName (event) {
                this.activeInfo = event
                this.userCenterSdk()
            },
            childPhone (event) {
                this.activeInfo = event
                this.userCenterSdk()
            },
            childPwd (event) {
                this.activeInfo = event
                this.userCenterSdk()
            },
            childPaySetup (event) {
                this.activeInfo = event
                this.userCenterSdk()
            },
            childPayModify (event) {
                this.activeInfo = event
                this.userCenterSdk()
            },
            onSetup (index) {
                if (index == 0) this.$router.push('/base-my-trumpet')
                if (index == 1 && this.objData.is_auth != 1) this.$router.push('/base-real-name')
                if (index == 1 && this.objData.is_auth == 1) this.$router.push('/base-real-name-modify')
                // 退出登录
                if (index == 3) {
                    sessionStorage.clear()
                    if(this.config.system == 2){
                        window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_logout'})
                    } else {
                        window.Android.logout()
                    }
                }
            },
            // 获取用户信息
            userCenterSdk () {
                this.uid = this.$route.query.uid ? this.$route.query.uid : JSON.parse(sessionStorage.getItem('accountData')).uid
                let options = {
                    uid: this.uid
                };
                options.sign = this.util.getSign(options)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=user_center_sdk', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.iscentent = true
                        this.objData = res.data.data
                        this.logo = this.objData.icon_url ? this.objData.icon_url : require('images/user_logo.png')
                        this.$store.commit('setUserName', this.objData.username)
                        this.fslname = this.objData.nick_name || this.objData.username
                        this.ispayPwd = this.objData.is_pay_pass
                        sessionStorage.setItem('setUserData', JSON.stringify(this.objData))
                    }
                })
            }
        },
        created () {
            let obj = {
                uid: this.$route.query.uid,
                cuid: this.$route.query.cuid,
                appid: this.$route.query.appid,
                appkey: this.$route.query.appkey,
                channel: this.$route.query.channel,
                system: this.$route.query.system,
                coinEnable: this.$route.query.coinEnable,
                // isHasBox 0、未安装app 1、已安装app
                isHasBox: this.$route.query.isHasBox,
                // 厂商
                maker: this.$route.query.maker,
                // 手机类型
                mobile_model: this.$route.query.mobileModel,
                // 手机设备号
                machine_code: this.$route.query.machine_code,
                // 设备ID
                machine_id: this.$route.query.androidId,
                // 系统版本
                system_version: this.$route.query.versionName,
                // 广告图片跳转链接
                getAdLinkUrl: this.$route.query.adLinkUrl,
                // 广告图片地址
                getAdImageUrl: this.$route.query.adImageUrl,
                // 是否显示广告图片
                // isDisplayAd: allUrlParams.isDisplayAd,
                // 是否开启注册
                isRegisterEnabled: this.$route.query.registerEnabled,
                // 是否开启实名认证
                isNameAuthEnabled: this.$route.query.nameAuthEnabled,
                // 是否显示平台币和平台币支付
                isPlatformMoneyEnabled: this.$route.query.platformMoneyEnabled,
                // 是否开启绑定手机
                isBindMobileEnabled: this.$route.query.bindMobileEnabled,
                // 折扣
                discount: this.$route.query.discount,
                // 云玩
                isCloudPlay:this.$route.query.isCloudPlay  
            }
            // 进入用户中心时存储url参数
            if (this.$route.query.uid || this.$route.query.appid) {
                sessionStorage.setItem('accountData', JSON.stringify(obj))
            }
            // 云玩
            this.isCloudPlay= JSON.parse(sessionStorage.getItem('accountData')).isCloudPlay==1?1:0   
            if(this.isCloudPlay==1){
                this.setupList = this.setupList.filter(item=>item.name !='退出登录')
            }

            this.isHasBox = JSON.parse(sessionStorage.getItem('accountData')).isHasBox
            if (sessionStorage.getItem('setUserData')) {
                this.objData = JSON.parse(sessionStorage.getItem('setUserData'))
                this.iscentent = true
                this.logo = this.objData.icon_url ? this.objData.icon_url : require('images/user_logo.png')
                this.$store.commit('setUserName', this.objData.username)
                this.fslname = this.objData.nick_name || this.objData.username
                this.ispayPwd = this.objData.is_pay_pass
            } else {
                this.userCenterSdk()
            }
            this.userData = JSON.parse(sessionStorage.getItem('userData'))
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-account {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        overflow-y: scroll;
        position: relative;
        .header-top {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            .title {
                font-size: 51px;
                text-align: center;
            }
            .service-img {
                width: 192px;
                height: 132px;
                position: absolute;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width: 72px;
                    height: 72px;
                }
            }
        }
        .curve-bg {
            width: 100%;
            height: 258px;
            img {
                width: 100%;
                height: 300px;
            }
            .header {
                width: 100%;
                position: absolute;
                top: 132px;
                .header-bottom {
                    padding-left: 105px;
                    display: flex;
                    .logo {
                        width: 150px;
                        height: 150px;
                        border-radius: 50%;
                        margin-right: 30px;
                    }
                    .real-info {
                        height: 75px;
                        margin-top: 10px;
                        display: flex;
                        align-items: center;
                    }
                    .real-name {
                        max-width: 360px;
                        font-size: 48px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .real-img {
                        width: 48px;
                        height: 48px;
                        margin-left: 14px;
                        position: relative;
                        top: 5px;
                    }
                    .real-type {
                        min-width: 120px;
                        height: 48px;
                        font-size: 30px;
                        border-radius: 3px;
                        background: rgba(255, 255, 255, 0.2);
                        margin-left: 15px;
                        position: relative;
                        top: 2px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .istype {
                        background: linear-gradient(0deg, #F3DABB, #D6A269);
                    }
                    .account {
                        font-size: 33px;
                        margin-top: 5px;
                    }
                }
            }
        }
        .member {
            width: 960px;
            height: 150px;
            margin: -78px auto 0;
            position: relative;
            z-index: 1;
            img {
                width: 960px;
                height: 150px;
            }
        }
        .quick-box {
            margin: 0 60px;
            margin-top: 45px;
            display: flex;
            justify-content: space-between;
            .quick {
                width: 288px;
                height: 240px;
                font-size: 39px;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img {
                    width: 75px;
                    height: 75px;
                    margin-bottom: 16px;
                }
            }
        }
        .list-box {
            margin: 0 60px;
            overflow: hidden;
            margin-top: 45px;
            .list {
                height: 120px;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                .left {
                    height: 100%;
                    font-size: 42px;
                    float: left;
                    display: flex;
                    align-items: center;
                    img {
                        width: 48px;
                        height: 48px;
                        margin-right: 40px;
                    }
                }
                .right {
                    height: 100%;
                    font-size: 36px;
                    float: right;
                    display: flex;
                    align-items: center;
                    .max-name {
                        max-width: 400px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .switch {
                        width: 120px;
                        height: 60px;
                        border-radius: 30px;
                        background: rgba(255, 255, 255, 0.5);
                        padding: 0 2px;
                        transition: all 0.3s;
                        display: flex;
                        align-items: center;
                    }
                    .isswitch {
                        background: $color;
                    }
                    .ball {
                        width: 54px;
                        height: 54px;
                        border-radius: 50%;
                        background: #fff;
                        transition: all 0.3s;
                    }
                    .isball {
                        margin-left: 64px;
                    }
                    img {
                        width: 36px;
                        height: 36px;
                        margin-left: 30px;
                        position: relative;
                        top: 2px;
                    }
                }
            }
            .list:first-child {
                border-radius: 18px 18px 0 0;
            }
            .list:last-child {
                border-radius: 0 0 18px 18px;
                border-bottom: 0;
            }
        }
        .setup {
            margin-top: 30px;
        }
        .isapp {
            color: $color;
            border-radius: 18px;
            background: rgba($color, 0.2);
            margin: 30px 60px 60px;
        }
    }
    // 竖屏css
    .account-sp {
        width: 100%;
        height: 100%;
        border-radius: 60px 0 0 0;
        .header-top {
            height: 240px;
            border-radius: 60px 0 0 0;
            overflow: hidden;
            .title {
                font-size: 92px;
            }
            .service-img {
                width: 290px;
                height: 240px;
                img {
                    width: 130px;
                    height: 130px;
                }
            }
        }
        .curve-bg {
            height: 469px;
            img {
                width: 100%;
                height: 520px;
            }
            .header {
                width: 100%;
                top: 240px;
                .header-bottom {
                    padding-left: 190px;
                    .logo {
                        width: 272px;
                        height: 272px;
                        margin-right: 54px;
                    }
                    .real-info {
                        height: 136px;
                        margin-top: 18px;
                    }
                    .real-name {
                        max-width: 654px;
                        font-size: 87px;
                    }
                    .real-img {
                        width: 87px;
                        height: 87px;
                        margin-left: 25px;
                        top: 9px;
                    }
                    .real-type {
                        min-width: 218px;
                        height: 87px;
                        font-size: 54px;
                        border-radius: 5px;
                        margin-left: 27px;
                        top: 3px;
                    }
                    .account {
                        font-size: 60px;
                        margin-top: 9px;
                    }
                }
            }
        }
        .member {
            width: 100%;
            height: 220px;
            margin-top: -141px;
            padding: 0 90px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .quick-box {
            margin: 0 90px;
            margin-top: 60px;
            .quick {
                width: 420px;
                height: 360px;
                font-size: 63px;
                border-radius: 32px;
                img {
                    width: 110px;
                    height: 110px;
                    margin-bottom: 29px;
                }
            }
        }
        .list-box {
            margin: 0 90px;
            margin-top: 60px;
            .list {
                height: 200px;
                padding: 0 60px;
                .left {
                    height: 100%;
                    font-size: 70px;
                    img {
                        width: 87px;
                        height: 87px;
                        margin-right: 60px;
                    }
                }
                .right {
                    font-size: 60px;
                    .max-name {
                        max-width: 560px;
                    }
                    .switch {
                        width: 200px;
                        height: 90px;
                        border-radius: 54px;
                        padding: 0 3px;
                    }
                    .ball {
                        width: 90px;
                        height: 90px;
                        border-radius: 50%;
                    }
                    .isball {
                        margin-left: 107px;
                    }
                    img {
                        width: 60px;
                        height: 60px;
                        margin-left: 54px;
                        top: 3px;
                    }
                }
            }
            .list:first-child {
                border-radius: 18px 18px 0 0;
            }
            .list:last-child {
                border-radius: 0 0 18px 18px;
                border-bottom: 0;
            }
        }
        .setup {
            margin-top: 45px;
        }
        .isapp {
            color: $color;
            border-radius: 18px;
            background: rgba($color, 0.2);
            margin: 45px 90px 90px;
        }
    }
</style>